// Per-domain app-version markers.
//
// Each data domain (batches, recipes, inventory) tracks the app version it
// last did a full fetch under. A single shared marker caused races: whichever
// context refreshed first cleared the flag for all the others.

const LEGACY_KEY = 'brewfather_cache_app_version';

const domainKey = (domain: string) => `${LEGACY_KEY}_${domain}`;

export const hasAppVersionChanged = (domain: string, currentVersion: string): boolean => {
  const stored = localStorage.getItem(domainKey(domain)) ?? localStorage.getItem(LEGACY_KEY);
  if (!stored) return true;
  return stored !== currentVersion;
};

export const updateCachedAppVersion = (domain: string, currentVersion: string): void => {
  localStorage.setItem(domainKey(domain), currentVersion);
};
